module.exports = __webpack_public_path__ + "img/merge-pick-image.f6e2ba15.gif";